import type { KBArticle } from './types';
import articlesData from './kb/articles.json';

const articles: KBArticle[] = articlesData as KBArticle[];

// Build inverted index at module load
const invertedIndex = new Map<string, Set<string>>();

for (const article of articles) {
  const terms = [
    ...article.title.toLowerCase().split(/\W+/).filter(w => w.length > 2),
    ...article.tags.map(t => t.toLowerCase()),
    ...article.body.toLowerCase().split(/\W+/).filter(w => w.length > 3),
  ];
  for (const term of terms) {
    if (!invertedIndex.has(term)) invertedIndex.set(term, new Set());
    invertedIndex.get(term)!.add(article.id);
  }
}

export function searchKB(query: string, limit = 3): KBArticle[] {
  if (!query.trim()) return [];

  const queryTerms = query.toLowerCase().split(/\W+/).filter(w => w.length > 2);
  const scores = new Map<string, number>();

  for (const term of queryTerms) {
    // Exact tag match: +3 points
    for (const article of articles) {
      if (article.tags.some(t => t.toLowerCase() === term)) {
        scores.set(article.id, (scores.get(article.id) ?? 0) + 3);
      }
    }

    // Title word match: +2 points
    for (const article of articles) {
      if (article.title.toLowerCase().includes(term)) {
        scores.set(article.id, (scores.get(article.id) ?? 0) + 2);
      }
    }

    // Body occurrence via inverted index: +1 point
    const matches = invertedIndex.get(term);
    if (matches) {
      matches.forEach(id => {
        scores.set(id, (scores.get(id) ?? 0) + 1);
      });
    }
  }

  return Array.from(scores.entries())
    .sort(([, a], [, b]) => b - a)
    .slice(0, limit)
    .map(([id]) => articles.find(a => a.id === id)!)
    .filter(Boolean);
}
